export default __webpack_public_path__ + "static/media/silencer-protector.291e32de.mp4";